import { render, staticRenderFns } from "./PortStatistics.vue?vue&type=template&id=31c3c184&"
import script from "./PortStatistics.vue?vue&type=script&lang=js&"
export * from "./PortStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports